import { APIHelper } from '@archistarai/auth-frontend';

export const DEFAULT_PAGE_SIZE = 250;

// Walks a take/skip paginated AdminAPI list endpoint and returns every row.
export async function getAllPages(url, { pageSize = DEFAULT_PAGE_SIZE } = {}) {
  const separator = url.includes('?') ? '&' : '?';
  const rows = [];
  let skip = 0;
  for (;;) {
    const {
      data: { data }
    } = await APIHelper.AdminAPI.get(`${url}${separator}take=${pageSize}&skip=${skip}`);
    const page = data || [];
    rows.push(...page);
    // Stop on any page that is not exactly full, so a backend ignoring take cannot loop us
    if (page.length !== pageSize) {
      return rows;
    }
    skip += pageSize;
  }
}
